// // // // // // // import { useState, useEffect } from "react";
// // // // // // // import {
// // // // // // //   Box,
// // // // // // //   Card,
// // // // // // //   CardContent,
// // // // // // //   Typography,
// // // // // // //   TextField,
// // // // // // //   Button,
// // // // // // //   MenuItem,
// // // // // // //   Select,
// // // // // // //   FormControl,
// // // // // // //   InputLabel,
// // // // // // //   Alert,
// // // // // // //   Grid,
// // // // // // // } from "@mui/material";
// // // // // // // import axiosClient from "../axiosClient";
// // // // // // // import { useTranslation } from "react-i18next";

// // // // // // // const CreateIssue = () => {
// // // // // // //   const { t } = useTranslation();
// // // // // // //   const [technicians, setTechnicians] = useState([]);
// // // // // // //   const [message, setMessage] = useState(null);
// // // // // // //   const [error, setError] = useState(null);

// // // // // // //   const [formData, setFormData] = useState({
// // // // // // //     title: "",
// // // // // // //     description: "",
// // // // // // //     priority: "MEDIUM",
// // // // // // //     status: "OPEN",
// // // // // // //     assigned_to: "", // ID of the Technician
// // // // // // //   });

// // // // // // //   // Fetch technicians to populate the assignment dropdown
// // // // // // //   useEffect(() => {
// // // // // // //     const fetchTechs = async () => {
// // // // // // //       try {
// // // // // // //         const res = await axiosClient.get("auth/technicians/");
// // // // // // //         setTechnicians(res.data);
// // // // // // //       } catch (err) {
// // // // // // //         console.error("Could not fetch technicians", err);
// // // // // // //       }
// // // // // // //     };
// // // // // // //     fetchTechs();
// // // // // // //   }, []);

// // // // // // //   const handleChange = (e) => {
// // // // // // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // // // // // //   };

// // // // // // //   const handleSubmit = async (e) => {
// // // // // // //     e.preventDefault();
// // // // // // //     setError(null);
// // // // // // //     setMessage(null);

// // // // // // //     try {
// // // // // // //       // POST to the endpoint verified in your terminal check
// // // // // // //       await axiosClient.post("api/issues/", formData);
// // // // // // //       setMessage(t("Issue created successfully!"));
// // // // // // //       setFormData({
// // // // // // //         title: "",
// // // // // // //         description: "",
// // // // // // //         priority: "MEDIUM",
// // // // // // //         status: "OPEN",
// // // // // // //         assigned_to: "",
// // // // // // //       });
// // // // // // //     } catch (err) {
// // // // // // //       setError(err.response?.data || t("Error creating issue"));
// // // // // // //     }
// // // // // // //   };

// // // // // // //   return (
// // // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 8 }}>
// // // // // // //         <CardContent>
// // // // // // //           <Typography variant="h5" mb={3} fontWeight="bold">
// // // // // // //             {t("Log New Issue / Ticket")}
// // // // // // //           </Typography>

// // // // // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{t("Please check the fields and try again.")}</Alert>}

// // // // // // //           <form onSubmit={handleSubmit}>
// // // // // // //             <Grid container spacing={2}>
// // // // // // //               <Grid item xs={12}>
// // // // // // //                 <TextField
// // // // // // //                   fullWidth
// // // // // // //                   label={t("Issue Title")}
// // // // // // //                   name="title"
// // // // // // //                   value={formData.title}
// // // // // // //                   onChange={handleChange}
// // // // // // //                   required
// // // // // // //                 />
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12}>
// // // // // // //                 <TextField
// // // // // // //                   fullWidth
// // // // // // //                   label={t("Description")}
// // // // // // //                   name="description"
// // // // // // //                   multiline
// // // // // // //                   rows={4}
// // // // // // //                   value={formData.description}
// // // // // // //                   onChange={handleChange}
// // // // // // //                   required
// // // // // // //                 />
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12} sm={6}>
// // // // // // //                 <FormControl fullWidth>
// // // // // // //                   <InputLabel>{t("Priority")}</InputLabel>
// // // // // // //                   <Select
// // // // // // //                     name="priority"
// // // // // // //                     value={formData.priority}
// // // // // // //                     label={t("Priority")}
// // // // // // //                     onChange={handleChange}
// // // // // // //                   >
// // // // // // //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// // // // // // //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// // // // // // //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// // // // // // //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// // // // // // //                   </Select>
// // // // // // //                 </FormControl>
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12} sm={6}>
// // // // // // //                 <FormControl fullWidth>
// // // // // // //                   <InputLabel>{t("Assign To Technician")}</InputLabel>
// // // // // // //                   <Select
// // // // // // //                     name="assigned_to"
// // // // // // //                     value={formData.assigned_to}
// // // // // // //                     label={t("Assign To Technician")}
// // // // // // //                     onChange={handleChange}
// // // // // // //                   >
// // // // // // //                     <MenuItem value=""><em>{t("Unassigned")}</em></MenuItem>
// // // // // // //                     {technicians.map((tech) => (
// // // // // // //                       <MenuItem key={tech.id} value={tech.id}>
// // // // // // //                         {tech.first_name} {tech.last_name}
// // // // // // //                       </MenuItem>
// // // // // // //                     ))}
// // // // // // //                   </Select>
// // // // // // //                 </FormControl>
// // // // // // //               </Grid>

// // // // // // //               <Grid item xs={12}>
// // // // // // //                 <Box display="flex" gap={2} mt={2}>
// // // // // // //                   <Button type="submit" variant="contained" color="primary" size="large">
// // // // // // //                     {t("Create Issue")}
// // // // // // //                   </Button>
// // // // // // //                   <Button variant="outlined" color="secondary" onClick={() => setFormData({title: "", description: "", priority: "MEDIUM", status: "OPEN", assigned_to: ""})}>
// // // // // // //                     {t("Clear")}
// // // // // // //                   </Button>
// // // // // // //                 </Box>
// // // // // // //               </Grid>
// // // // // // //             </Grid>
// // // // // // //           </form>
// // // // // // //         </CardContent>
// // // // // // //       </Card>
// // // // // // //     </Box>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default CreateIssue;


// // // // // // import { useState, useEffect } from "react";
// // // // // // import {
// // // // // //   Box,
// // // // // //   Card,
// // // // // //   CardContent,
// // // // // //   Typography,
// // // // // //   TextField,
// // // // // //   Button,
// // // // // //   MenuItem,
// // // // // //   Select,
// // // // // //   FormControl,
// // // // // //   InputLabel,
// // // // // //   Alert,
// // // // // //   Grid,
// // // // // // } from "@mui/material";
// // // // // // import axiosClient from "../axiosClient";
// // // // // // import { useTranslation } from "react-i18next";

// // // // // // const CreateIssue = () => {
// // // // // //   const { t } = useTranslation();
// // // // // //   const [technicians, setTechnicians] = useState([]);
// // // // // //   const [message, setMessage] = useState(null);
// // // // // //   const [error, setError] = useState(null);

// // // // // //   const [formData, setFormData] = useState({
// // // // // //     title: "",
// // // // // //     description: "",
// // // // // //     room_number: "", // 🛠️ Added Room Number to state
// // // // // //     priority: "MEDIUM",
// // // // // //     status: "OPEN",
// // // // // //     assigned_to: "", // ID of the Technician
// // // // // //   });

// // // // // //   // Fetch technicians to populate the assignment dropdown
// // // // // //   useEffect(() => {
// // // // // //     const fetchTechs = async () => {
// // // // // //       try {
// // // // // //         const res = await axiosClient.get("auth/technicians/");
// // // // // //         setTechnicians(res.data);
// // // // // //       } catch (err) {
// // // // // //         console.error("Could not fetch technicians", err);
// // // // // //       }
// // // // // //     };
// // // // // //     fetchTechs();
// // // // // //   }, []);

// // // // // //   const handleChange = (e) => {
// // // // // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // // // // //   };

// // // // // //   const handleSubmit = async (e) => {
// // // // // //     e.preventDefault();
// // // // // //     setError(null);
// // // // // //     setMessage(null);

// // // // // //     try {
// // // // // //       // POST to the endpoint verified in your terminal check
// // // // // //       await axiosClient.post("api/issues/", formData);
// // // // // //       setMessage(t("Issue created successfully!"));
// // // // // //       // Reset form
// // // // // //       setFormData({
// // // // // //         title: "",
// // // // // //         description: "",
// // // // // //         room_number: "", // 🛠️ Reset Room Number
// // // // // //         priority: "MEDIUM",
// // // // // //         status: "OPEN",
// // // // // //         assigned_to: "",
// // // // // //       });
// // // // // //     } catch (err) {
// // // // // //       setError(err.response?.data || t("Error creating issue"));
// // // // // //     }
// // // // // //   };

// // // // // //   return (
// // // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // // //       <Card sx={{ width: "100%", maxWidth: 800, elevation: 8 }}>
// // // // // //         <CardContent>
// // // // // //           <Typography variant="h5" mb={3} fontWeight="bold">
// // // // // //             {t("Log New Issue / Ticket")}
// // // // // //           </Typography>

// // // // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{t("Please check the fields and try again.")}</Alert>}

// // // // // //           <form onSubmit={handleSubmit}>
// // // // // //             <Grid container spacing={2}>
// // // // // //               <Grid item xs={12} sm={8}>
// // // // // //                 <TextField
// // // // // //                   fullWidth
// // // // // //                   label={t("Issue Title")}
// // // // // //                   name="title"
// // // // // //                   value={formData.title}
// // // // // //                   onChange={handleChange}
// // // // // //                   required
// // // // // //                 />
// // // // // //               </Grid>

// // // // // //               {/* 🛠️ NEW ROOM NUMBER FIELD */}
// // // // // //               <Grid item xs={12} sm={4}>
// // // // // //                 <TextField
// // // // // //                   fullWidth
// // // // // //                   label={t("Room Number")}
// // // // // //                   name="room_number"
// // // // // //                   value={formData.room_number}
// // // // // //                   onChange={handleChange}
// // // // // //                   required
// // // // // //                   placeholder="e.g. 101"
// // // // // //                 />
// // // // // //               </Grid>

// // // // // //               <Grid item xs={12}>
// // // // // //                 <TextField
// // // // // //                   fullWidth
// // // // // //                   label={t("Description")}
// // // // // //                   name="description"
// // // // // //                   multiline
// // // // // //                   rows={4}
// // // // // //                   value={formData.description}
// // // // // //                   onChange={handleChange}
// // // // // //                   required
// // // // // //                 />
// // // // // //               </Grid>

// // // // // //               <Grid item xs={12} sm={6}>
// // // // // //                 <FormControl fullWidth>
// // // // // //                   <InputLabel>{t("Priority")}</InputLabel>
// // // // // //                   <Select
// // // // // //                     name="priority"
// // // // // //                     value={formData.priority}
// // // // // //                     label={t("Priority")}
// // // // // //                     onChange={handleChange}
// // // // // //                   >
// // // // // //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// // // // // //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// // // // // //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// // // // // //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// // // // // //                   </Select>
// // // // // //                 </FormControl>
// // // // // //               </Grid>

// // // // // //               <Grid item xs={12} sm={6}>
// // // // // //                 <FormControl fullWidth>
// // // // // //                   <InputLabel>{t("Assign To Technician")}</InputLabel>
// // // // // //                   <Select
// // // // // //                     name="assigned_to"
// // // // // //                     value={formData.assigned_to}
// // // // // //                     label={t("Assign To Technician")}
// // // // // //                     onChange={handleChange}
// // // // // //                   >
// // // // // //                     <MenuItem value=""><em>{t("Unassigned")}</em></MenuItem>
// // // // // //                     {technicians.map((tech) => (
// // // // // //                       <MenuItem key={tech.id} value={tech.id}>
// // // // // //                         {tech.first_name} {tech.last_name}
// // // // // //                       </MenuItem>
// // // // // //                     ))}
// // // // // //                   </Select>
// // // // // //                 </FormControl>
// // // // // //               </Grid>

// // // // // //               <Grid item xs={12}>
// // // // // //                 <Box display="flex" gap={2} mt={2}>
// // // // // //                   <Button type="submit" variant="contained" color="primary" size="large">
// // // // // //                     {t("Create Issue")}
// // // // // //                   </Button>
// // // // // //                   <Button 
// // // // // //                     variant="outlined" 
// // // // // //                     color="secondary" 
// // // // // //                     onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "OPEN", assigned_to: ""})}
// // // // // //                   >
// // // // // //                     {t("Clear")}
// // // // // //                   </Button>
// // // // // //                 </Box>
// // // // // //               </Grid>
// // // // // //             </Grid>
// // // // // //           </form>
// // // // // //         </CardContent>
// // // // // //       </Card>
// // // // // //     </Box>
// // // // // //   );
// // // // // // };

// // // // // // export default CreateIssue;

// // // // // import { useState, useEffect } from "react";
// // // // // import {
// // // // //   Box,
// // // // //   Card,
// // // // //   CardContent,
// // // // //   Typography,
// // // // //   TextField,
// // // // //   Button,
// // // // //   MenuItem,
// // // // //   Select,
// // // // //   FormControl,
// // // // //   InputLabel,
// // // // //   Alert,
// // // // //   Grid,
// // // // // } from "@mui/material";
// // // // // import axiosClient from "../axiosClient";
// // // // // import { useTranslation } from "react-i18next";

// // // // // const CreateIssue = () => {
// // // // //   const { t } = useTranslation();
// // // // //   const [technicians, setTechnicians] = useState([]);
// // // // //   const [message, setMessage] = useState(null);
// // // // //   const [error, setError] = useState(null);

// // // // //   const [formData, setFormData] = useState({
// // // // //     title: "",
// // // // //     description: "",
// // // // //     room_number: "", 
// // // // //     priority: "MEDIUM",
// // // // //     status: "OPEN",
// // // // //     assigned_technician: "", // Matched to your Django Model/Serializer
// // // // //   });

// // // // //   useEffect(() => {
// // // // //     const fetchTechs = async () => {
// // // // //       try {
// // // // //         const res = await axiosClient.get("auth/technicians/");
// // // // //         setTechnicians(res.data);
// // // // //       } catch (err) {
// // // // //         console.error("Could not fetch technicians", err);
// // // // //       }
// // // // //     };
// // // // //     fetchTechs();
// // // // //   }, []);

// // // // //   const handleChange = (e) => {
// // // // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // // // //   };

// // // // //   const handleSubmit = async (e) => {
// // // // //     e.preventDefault();
// // // // //     setError(null);
// // // // //     setMessage(null);

// // // // //     try {
// // // // //       // Logic: If assigned_technician is empty string, send null
// // // // //       const dataToSubmit = {
// // // // //         ...formData,
// // // // //         assigned_technician: formData.assigned_technician || null
// // // // //       };

// // // // //       await axiosClient.post("api/issues/", dataToSubmit);
// // // // //       setMessage(t("Issue created successfully!"));
// // // // //       setFormData({
// // // // //         title: "",
// // // // //         description: "",
// // // // //         room_number: "", 
// // // // //         priority: "MEDIUM",
// // // // //         status: "OPEN",
// // // // //         assigned_technician: "",
// // // // //       });
// // // // //     } catch (err) {
// // // // //       console.error("Submit Error:", err.response?.data);
// // // // //       setError(err.response?.data || t("Error creating issue"));
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // //       <Card sx={{ width: "100%", maxWidth: 900, elevation: 8 }}>
// // // // //         <CardContent>
// // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // //             {t("Log New Issue / Ticket")}
// // // // //           </Typography>

// // // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{t("Please check the fields and try again.")}</Alert>}

// // // // //           <form onSubmit={handleSubmit}>
// // // // //             <Grid container spacing={2}>
// // // // //               {/* Issue Title & Room Number on same line per image_215a1f */}
// // // // //               <Grid item xs={12} sm={8}>
// // // // //                 <TextField
// // // // //                   fullWidth
// // // // //                   label={t("Issue Title *")}
// // // // //                   name="title"
// // // // //                   value={formData.title}
// // // // //                   onChange={handleChange}
// // // // //                   required
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={4}>
// // // // //                 <TextField
// // // // //                   fullWidth
// // // // //                   label={t("Room Number *")}
// // // // //                   name="room_number"
// // // // //                   value={formData.room_number}
// // // // //                   onChange={handleChange}
// // // // //                   required
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12}>
// // // // //                 <TextField
// // // // //                   fullWidth
// // // // //                   label={t("Description *")}
// // // // //                   name="description"
// // // // //                   multiline
// // // // //                   rows={4}
// // // // //                   value={formData.description}
// // // // //                   onChange={handleChange}
// // // // //                   required
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={6}>
// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel>{t("Priority")}</InputLabel>
// // // // //                   <Select
// // // // //                     name="priority"
// // // // //                     value={formData.priority}
// // // // //                     label={t("Priority")}
// // // // //                     onChange={handleChange}
// // // // //                   >
// // // // //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// // // // //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// // // // //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// // // // //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={6}>
// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel>{t("Assign To Technician")}</InputLabel>
// // // // //                   <Select
// // // // //                     name="assigned_technician"
// // // // //                     value={formData.assigned_technician}
// // // // //                     label={t("Assign To Technician")}
// // // // //                     onChange={handleChange}
// // // // //                   >
// // // // //                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // // // //                     {technicians.map((tech) => (
// // // // //                       <MenuItem key={tech.id} value={tech.id}>
// // // // //                         {tech.first_name} {tech.last_name}
// // // // //                       </MenuItem>
// // // // //                     ))}
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Grid>

// // // // //               <Grid item xs={12}>
// // // // //                 <Box display="flex" gap={2} mt={2}>
// // // // //                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none' }}>
// // // // //                     {t("CREATE ISSUE")}
// // // // //                   </Button>
// // // // //                   <Button 
// // // // //                     variant="outlined" 
// // // // //                     color="secondary" 
// // // // //                     size="large"
// // // // //                     onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "OPEN", assigned_technician: ""})}
// // // // //                   >
// // // // //                     {t("ΚΑΘΑΡΙΣΜΟΣ")}
// // // // //                   </Button>
// // // // //                 </Box>
// // // // //               </Grid>
// // // // //             </Grid>
// // // // //           </form>
// // // // //         </CardContent>
// // // // //       </Card>
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default CreateIssue;


// // // // // import { useState, useEffect } from "react";
// // // // // import {
// // // // //   Box,
// // // // //   Card,
// // // // //   CardContent,
// // // // //   Typography,
// // // // //   TextField,
// // // // //   Button,
// // // // //   MenuItem,
// // // // //   Select,
// // // // //   FormControl,
// // // // //   InputLabel,
// // // // //   Alert,
// // // // //   Grid,
// // // // // } from "@mui/material";
// // // // // import axiosClient from "../axiosClient";
// // // // // import { useTranslation } from "react-i18next";

// // // // // const CreateIssue = () => {
// // // // //   const { t } = useTranslation();
// // // // //   const [technicians, setTechnicians] = useState([]);
// // // // //   const [message, setMessage] = useState(null);
// // // // //   const [error, setError] = useState(null);

// // // // //   const [formData, setFormData] = useState({
// // // // //     title: "",
// // // // //     description: "",
// // // // //     room_number: "", 
// // // // //     priority: "MEDIUM",
// // // // //     status: "OPEN",
// // // // //     assigned_technician: "", // Matched to your Django Model/Serializer
// // // // //   });

// // // // //   useEffect(() => {
// // // // //     const fetchTechs = async () => {
// // // // //       try {
// // // // //         const res = await axiosClient.get("auth/technicians/");
// // // // //         setTechnicians(res.data);
// // // // //       } catch (err) {
// // // // //         console.error("Could not fetch technicians", err);
// // // // //       }
// // // // //     };
// // // // //     fetchTechs();
// // // // //   }, []);

// // // // //   const handleChange = (e) => {
// // // // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // // // //   };

// // // // //   const handleSubmit = async (e) => {
// // // // //     e.preventDefault();
// // // // //     setError(null);
// // // // //     setMessage(null);

// // // // //     try {
// // // // //       // Logic: If assigned_technician is empty string, send null
// // // // //       const dataToSubmit = {
// // // // //         ...formData,
// // // // //         assigned_technician: formData.assigned_technician || null
// // // // //       };

// // // // //       await axiosClient.post("api/issues/", dataToSubmit);
// // // // //       setMessage(t("Issue created successfully!"));
// // // // //       setFormData({
// // // // //         title: "",
// // // // //         description: "",
// // // // //         room_number: "", 
// // // // //         priority: "MEDIUM",
// // // // //         status: "OPEN",
// // // // //         assigned_technician: "",
// // // // //       });
// // // // //     } catch (err) {
// // // // //       console.error("Submit Error:", err.response?.data);
// // // // //       setError(err.response?.data || t("Error creating issue"));
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <Box display="flex" justifyContent="center" mt={4}>
// // // // //       <Card sx={{ width: "100%", maxWidth: 900, elevation: 8 }}>
// // // // //         <CardContent>
// // // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center">
// // // // //             {t("Log New Issue / Ticket")}
// // // // //           </Typography>

// // // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // // //           {error && <Alert severity="error" sx={{ mb: 2 }}>{t("Please check the fields and try again.")}</Alert>}

// // // // //           <form onSubmit={handleSubmit}>
// // // // //             <Grid container spacing={2}>
// // // // //               {/* Issue Title & Room Number on same line per image_215a1f */}
// // // // //               <Grid item xs={12} sm={8}>
// // // // //                 <TextField
// // // // //                   fullWidth
// // // // //                   label={t("Issue Title *")}
// // // // //                   name="title"
// // // // //                   value={formData.title}
// // // // //                   onChange={handleChange}
// // // // //                   required
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={4}>
// // // // //                 <TextField
// // // // //                   fullWidth
// // // // //                   label={t("Room Number *")}
// // // // //                   name="room_number"
// // // // //                   value={formData.room_number}
// // // // //                   onChange={handleChange}
// // // // //                   required
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12}>
// // // // //                 <TextField
// // // // //                   fullWidth
// // // // //                   label={t("Description *")}
// // // // //                   name="description"
// // // // //                   multiline
// // // // //                   rows={4}
// // // // //                   value={formData.description}
// // // // //                   onChange={handleChange}
// // // // //                   required
// // // // //                 />
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={6}>
// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel>{t("Priority")}</InputLabel>
// // // // //                   <Select
// // // // //                     name="priority"
// // // // //                     value={formData.priority}
// // // // //                     label={t("Priority")}
// // // // //                     onChange={handleChange}
// // // // //                   >
// // // // //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// // // // //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// // // // //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// // // // //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Grid>

// // // // //               <Grid item xs={12} sm={6}>
// // // // //                 <FormControl fullWidth>
// // // // //                   <InputLabel>{t("Assign To Technician")}</InputLabel>
// // // // //                   <Select
// // // // //                     name="assigned_technician"
// // // // //                     value={formData.assigned_technician}
// // // // //                     label={t("Assign To Technician")}
// // // // //                     onChange={handleChange}
// // // // //                   >
// // // // //                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // // // //                     {technicians.map((tech) => (
// // // // //                       <MenuItem key={tech.id} value={tech.id}>
// // // // //                         {tech.first_name} {tech.last_name}
// // // // //                       </MenuItem>
// // // // //                     ))}
// // // // //                   </Select>
// // // // //                 </FormControl>
// // // // //               </Grid>

// // // // //               <Grid item xs={12}>
// // // // //                 <Box display="flex" gap={2} mt={2}>
// // // // //                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none' }}>
// // // // //                     {t("CREATE ISSUE")}
// // // // //                   </Button>
// // // // //                   <Button 
// // // // //                     variant="outlined" 
// // // // //                     color="secondary" 
// // // // //                     size="large"
// // // // //                     onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "OPEN", assigned_technician: ""})}
// // // // //                   >
// // // // //                     {t("ΚΑΘΑΡΙΣΜΟΣ")}
// // // // //                   </Button>
// // // // //                 </Box>
// // // // //               </Grid>
// // // // //             </Grid>
// // // // //           </form>
// // // // //         </CardContent>
// // // // //       </Card>
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default CreateIssue;


// // // // import { useState, useEffect } from "react";
// // // // import {
// // // //   Box,
// // // //   Card,
// // // //   CardContent,
// // // //   Typography,
// // // //   TextField,
// // // //   Button,
// // // //   MenuItem,
// // // //   Select,
// // // //   FormControl,
// // // //   InputLabel,
// // // //   Alert,
// // // //   Grid,
// // // // } from "@mui/material";
// // // // import axiosClient from "../axiosClient";
// // // // import { useTranslation } from "react-i18next";

// // // // const CreateIssue = () => {
// // // //   const { t } = useTranslation();
// // // //   const [technicians, setTechnicians] = useState([]);
// // // //   const [message, setMessage] = useState(null);
// // // //   const [error, setError] = useState(null);

// // // //   const [formData, setFormData] = useState({
// // // //     title: "",
// // // //     description: "",
// // // //     room_number: "", 
// // // //     priority: "MEDIUM",
// // // //     status: "OPEN",
// // // //     assigned_technician: "", 
// // // //   });

// // // //   // 🛠️ FETCH LOGIC: Ensures we handle both array and object responses
// // // //   useEffect(() => {
// // // //     const fetchTechs = async () => {
// // // //       try {
// // // //         const res = await axiosClient.get("auth/technicians/");
// // // //         // Check if data is an array or inside a 'results' key
// // // //         const techData = Array.isArray(res.data) ? res.data : (res.data.results || []);
// // // //         setTechnicians(techData);
// // // //       } catch (err) {
// // // //         console.error("Could not fetch technicians", err);
// // // //       }
// // // //     };
// // // //     fetchTechs();
// // // //   }, []);

// // // //   const handleChange = (e) => {
// // // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // // //   };

// // // //   const handleSubmit = async (e) => {
// // // //     e.preventDefault();
// // // //     setError(null);
// // // //     setMessage(null);

// // // //     try {
// // // //       // Logic: If assigned_technician is empty string, send null so Django is happy
// // // //       const dataToSubmit = {
// // // //         ...formData,
// // // //         assigned_technician: formData.assigned_technician || null
// // // //       };

// // // //       await axiosClient.post("api/issues/", dataToSubmit);
// // // //       setMessage(t("Issue created successfully!"));
      
// // // //       // Reset Form
// // // //       setFormData({
// // // //         title: "",
// // // //         description: "",
// // // //         room_number: "", 
// // // //         priority: "MEDIUM",
// // // //         status: "OPEN",
// // // //         assigned_technician: "",
// // // //       });
// // // //     } catch (err) {
// // // //       console.error("Submit Error:", err.response?.data);
// // // //       // Display specific backend error if available
// // // //       setError(err.response?.data || t("Error creating issue"));
// // // //     }
// // // //   };

// // // //   return (
// // // //     <Box display="flex" justifyContent="center" mt={4} mb={4}>
// // // //       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
// // // //         <CardContent sx={{ p: 4 }}>
// // // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
// // // //             {t("Log New Issue / Ticket")}
// // // //           </Typography>

// // // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// // // //           {error && (
// // // //             <Alert severity="error" sx={{ mb: 2 }}>
// // // //               {typeof error === 'object' ? JSON.stringify(error) : t("Please check the fields and try again.")}
// // // //             </Alert>
// // // //           )}

// // // //           <form onSubmit={handleSubmit}>
// // // //             <Grid container spacing={3}>
// // // //               {/* Row 1: Title and Room Number */}
// // // //               <Grid item xs={12} sm={8}>
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   label={t("Issue Title *")}
// // // //                   name="title"
// // // //                   value={formData.title}
// // // //                   onChange={handleChange}
// // // //                   required
// // // //                 />
// // // //               </Grid>

// // // //               <Grid item xs={12} sm={4}>
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   label={t("Room Number *")}
// // // //                   name="room_number"
// // // //                   value={formData.room_number}
// // // //                   onChange={handleChange}
// // // //                   required
// // // //                 />
// // // //               </Grid>

// // // //               {/* Row 2: Description */}
// // // //               <Grid item xs={12}>
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   label={t("Description *")}
// // // //                   name="description"
// // // //                   multiline
// // // //                   rows={4}
// // // //                   value={formData.description}
// // // //                   onChange={handleChange}
// // // //                   required
// // // //                 />
// // // //               </Grid>

// // // //               {/* Row 3: Priority and Technician Selection */}
// // // //               <Grid item xs={12} sm={6}>
// // // //                 <FormControl fullWidth>
// // // //                   <InputLabel id="priority-label">{t("Priority")}</InputLabel>
// // // //                   <Select
// // // //                     labelId="priority-label"
// // // //                     name="priority"
// // // //                     value={formData.priority}
// // // //                     label={t("Priority")}
// // // //                     onChange={handleChange}
// // // //                   >
// // // //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// // // //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// // // //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// // // //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// // // //                   </Select>
// // // //                 </FormControl>
// // // //               </Grid>

// // // //               <Grid item xs={12} sm={6}>
// // // //                 <FormControl fullWidth>
// // // //                   <InputLabel id="tech-label">{t("Assign To Technician")}</InputLabel>
// // // //                   <Select
// // // //                     labelId="tech-label"
// // // //                     name="assigned_technician"
// // // //                     value={formData.assigned_technician}
// // // //                     label={t("Assign To Technician")}
// // // //                     onChange={handleChange}
// // // //                   >
// // // //                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // // //                     {technicians.length > 0 ? (
// // // //                       technicians.map((tech) => (
// // // //                       //   // <MenuItem key={tech.id} value={tech.id}>
// // // //                       //   //   {tech.first_name} {tech.last_name} ({tech.username})
// // // //                       //   // </MenuItem>
// // // //                       //   {tech.first_name || tech.last_name 
// // // //                       //     ? `${tech.first_name} ${tech.last_name}` 
// // // //                       //     : tech.username || tech.email}
// // // //                       // ))
// // // //                       <MenuItem key={tech.id} value={tech.id}>
// // // //     {/* Use username if first/last name are missing to avoid empty () */}
// // // //     {tech.first_name || tech.last_name 
// // // //       ? `${tech.first_name} ${tech.last_name}` 
// // // //       : tech.username || tech.email}
// // // //   </MenuItem>
// // // // ))}
// // // //                      : (
// // // //                       <MenuItem disabled>{t("No Technicians Found")}</MenuItem>
// // // //                     )}
// // // //                   </Select>
// // // //                 </FormControl>
// // // //               </Grid>

// // // //               {/* Action Buttons */}
// // // //               <Grid item xs={12}>
// // // //                 <Box display="flex" gap={2} mt={1}>
// // // //                   <Button 
// // // //                     type="submit" 
// // // //                     variant="contained" 
// // // //                     color="primary" 
// // // //                     size="large" 
// // // //                     sx={{ textTransform: 'none', px: 4 }}
// // // //                   >
// // // //                     {t("CREATE ISSUE")}
// // // //                   </Button>
// // // //                   <Button 
// // // //                     variant="outlined" 
// // // //                     color="secondary" 
// // // //                     size="large"
// // // //                     sx={{ textTransform: 'none' }}
// // // //                     onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "OPEN", assigned_technician: ""})}
// // // //                   >
// // // //                     {t("ΚΑΘΑΡΙΣΜΟΣ")}
// // // //                   </Button>
// // // //                 </Box>
// // // //               </Grid>
// // // //             </Grid>
// // // //           </form>
// // // //         </CardContent>
// // // //       </Card>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default CreateIssue;


// // // import { useState, useEffect } from "react";
// // // import {
// // //   Box,
// // //   Card,
// // //   CardContent,
// // //   Typography,
// // //   TextField,
// // //   Button,
// // //   MenuItem,
// // //   Select,
// // //   FormControl,
// // //   InputLabel,
// // //   Alert,
// // //   Grid,
// // // } from "@mui/material";
// // // import axiosClient from "../axiosClient";
// // // import { useTranslation } from "react-i18next";

// // // const CreateIssue = () => {
// // //   const { t } = useTranslation();
// // //   const [technicians, setTechnicians] = useState([]);
// // //   const [message, setMessage] = useState(null);
// // //   const [error, setError] = useState(null);

// // //   const [formData, setFormData] = useState({
// // //     title: "",
// // //     description: "",
// // //     room_number: "",
// // //     priority: "MEDIUM",
// // //     status: "OPEN",
// // //     assigned_technician: "",
// // //   });

// // //   // Fetch Technicians on component mount
// // //   useEffect(() => {
// // //     const fetchTechs = async () => {
// // //       try {
// // //         const res = await axiosClient.get("auth/technicians/");
// // //         // Handle different possible response structures
// // //         const techData = Array.isArray(res.data) ? res.data : (res.data.results || []);
// // //         setTechnicians(techData);
// // //       } catch (err) {
// // //         console.error("Could not fetch technicians", err);
// // //       }
// // //     };
// // //     fetchTechs();
// // //   }, []);

// // //   const handleChange = (e) => {
// // //     setFormData({ ...formData, [e.target.name]: e.target.value });
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setError(null);
// // //     setMessage(null);

// // //     try {
// // //       // Ensure assigned_technician is null if empty string (Django validation requirement)
// // //       const dataToSubmit = {
// // //         ...formData,
// // //         assigned_technician: formData.assigned_technician || null,
// // //       };

// // //       await axiosClient.post("api/issues/", dataToSubmit);
// // //       setMessage(t("Issue created successfully!"));

// // //       // Reset Form State
// // //       setFormData({
// // //         title: "",
// // //         description: "",
// // //         room_number: "",
// // //         priority: "MEDIUM",
// // //         status: "OPEN",
// // //         assigned_technician: "",
// // //       });
// // //     } catch (err) {
// // //       console.error("Submit Error:", err.response?.data);
// // //       // Display specific backend error message if it exists
// // //       setError(err.response?.data || t("Error creating issue"));
// // //     }
// // //   };

// // //   return (
// // //     <Box display="flex" justifyContent="center" mt={4} mb={4}>
// // //       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
// // //         <CardContent sx={{ p: 4 }}>
// // //           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
// // //             {t("Log New Issue / Ticket")}
// // //           </Typography>

// // //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
          
// // //           {error && (
// // //             <Alert severity="error" sx={{ mb: 2 }}>
// // //               {typeof error === 'object' ? JSON.stringify(error) : t("Please check the fields and try again.")}
// // //             </Alert>
// // //           )}

// // //           <form onSubmit={handleSubmit}>
// // //             <Grid container spacing={3}>
// // //               {/* Row 1: Title and Room Number */}
// // //               <Grid item xs={12} sm={8}>
// // //                 <TextField
// // //                   fullWidth
// // //                   label={t("Issue Title *")}
// // //                   name="title"
// // //                   value={formData.title}
// // //                   onChange={handleChange}
// // //                   required
// // //                 />
// // //               </Grid>

// // //               <Grid item xs={12} sm={4}>
// // //                 <TextField
// // //                   fullWidth
// // //                   label={t("Room Number *")}
// // //                   name="room_number"
// // //                   value={formData.room_number}
// // //                   onChange={handleChange}
// // //                   required
// // //                 />
// // //               </Grid>

// // //               {/* Row 2: Description */}
// // //               <Grid item xs={12}>
// // //                 <TextField
// // //                   fullWidth
// // //                   label={t("Description *")}
// // //                   name="description"
// // //                   multiline
// // //                   rows={4}
// // //                   value={formData.description}
// // //                   onChange={handleChange}
// // //                   required
// // //                 />
// // //               </Grid>

// // //               {/* Row 3: Priority and Technician Selection */}
// // //               <Grid item xs={12} sm={6}>
// // //                 <FormControl fullWidth>
// // //                   <InputLabel id="priority-label">{t("Priority")}</InputLabel>
// // //                   <Select
// // //                     labelId="priority-label"
// // //                     name="priority"
// // //                     value={formData.priority}
// // //                     label={t("Priority")}
// // //                     onChange={handleChange}
// // //                   >
// // //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// // //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// // //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// // //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// // //                   </Select>
// // //                 </FormControl>
// // //               </Grid>

// // //               <Grid item xs={12} sm={6}>
// // //                 <FormControl fullWidth>
// // //                   <InputLabel id="tech-label">{t("Assign To Technician")}</InputLabel>
// // //                   <Select
// // //                     labelId="tech-label"
// // //                     name="assigned_technician"
// // //                     value={formData.assigned_technician}
// // //                     label={t("Assign To Technician")}
// // //                     onChange={handleChange}
// // //                   >
// // //                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
// // //                     {technicians.length > 0 ? (
// // //                       technicians.map((tech) => (
// // //                         <MenuItem key={tech.id} value={tech.id}>
// // //                           {tech.first_name || tech.last_name
// // //                             ? `${tech.first_name} ${tech.last_name}`.trim()
// // //                             : tech.username || tech.email}
// // //                         </MenuItem>
// // //                       ))
// // //                     ) : (
// // //                       <MenuItem disabled>{t("No Technicians Found")}</MenuItem>
// // //                     )}
// // //                   </Select>
// // //                 </FormControl>
// // //               </Grid>

// // //               {/* Action Buttons */}
// // //               <Grid item xs={12}>
// // //                 <Box display="flex" gap={2} mt={1}>
// // //                   <Button
// // //                     type="submit"
// // //                     variant="contained"
// // //                     color="primary"
// // //                     size="large"
// // //                     sx={{ textTransform: "none", px: 4 }}
// // //                   >
// // //                     {t("CREATE ISSUE")}
// // //                   </Button>
// // //                   <Button
// // //                     variant="outlined"
// // //                     color="secondary"
// // //                     size="large"
// // //                     sx={{ textTransform: "none" }}
// // //                     onClick={() =>
// // //                       setFormData({
// // //                         title: "",
// // //                         description: "",
// // //                         room_number: "",
// // //                         priority: "MEDIUM",
// // //                         status: "OPEN",
// // //                         assigned_technician: "",
// // //                       })
// // //                     }
// // //                   >
// // //                     {t("ΚΑΘΑΡΙΣΜΟΣ")}
// // //                   </Button>
// // //                 </Box>
// // //               </Grid>
// // //             </Grid>
// // //           </form>
// // //         </CardContent>
// // //       </Card>
// // //     </Box>
// // //   );
// // // };

// // // export default CreateIssue;


// // import { useState, useEffect } from "react";
// // import {
// //   Box, Card, CardContent, Typography, TextField, Button,
// //   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// // } from "@mui/material";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";

// // const CreateIssue = () => {
// //   const { t } = useTranslation();
// //   const [technicians, setTechnicians] = useState([]);
// //   const [message, setMessage] = useState(null);
// //   const [error, setError] = useState(null);

// //   const [formData, setFormData] = useState({
// //     title: "",
// //     description: "",
// //     room_number: "",
// //     priority: "MEDIUM",
// //     status: "OPEN",
// //     assigned_technician: "", 
// //   });

// //   useEffect(() => {
// //     const fetchTechs = async () => {
// //       try {
// //         // 🛠️ Ensure this matches your specific technician API path
// //         const res = await axiosClient.get("auth/technicians/");
// //         const techData = Array.isArray(res.data) ? res.data : (res.data.results || []);
// //         setTechnicians(techData);
// //       } catch (err) {
// //         console.error("Could not fetch technicians", err);
// //       }
// //     };
// //     fetchTechs();
// //   }, []);

// //   const handleChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setError(null);
// //     setMessage(null);

// //     try {
// //       const dataToSubmit = {
// //         ...formData,
// //         // Send null if empty string to satisfy Django foreign key requirements
// //         assigned_technician: formData.assigned_technician || null
// //       };

// //       await axiosClient.post("api/issues/", dataToSubmit);
// //       setMessage(t("Issue created successfully!"));
// //       setFormData({
// //         title: "", description: "", room_number: "", 
// //         priority: "MEDIUM", status: "OPEN", assigned_technician: "",
// //       });
// //     } catch (err) {
// //       console.error("Submit Error:", err.response?.data);
// //       // Display specific error from backend if available
// //       setError(err.response?.data || t("Error creating issue"));
// //     }
// //   };

// //   return (
// //     <Box display="flex" justifyContent="center" mt={4} mb={4}>
// //       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
// //         <CardContent sx={{ p: 4 }}>
// //           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
// //             {t("Log New Issue / Ticket")}
// //           </Typography>

// //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{t("Please check the fields and try again.")}</Alert>}

// //           <form onSubmit={handleSubmit}>
// //             <Grid container spacing={3}>
// //               <Grid item xs={12} sm={8}>
// //                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
// //               </Grid>

// //               <Grid item xs={12} sm={4}>
// //                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
// //               </Grid>

// //               <Grid item xs={12}>
// //                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
// //               </Grid>

// //               <Grid item xs={12} sm={6}>
// //                 <FormControl fullWidth>
// //                   <InputLabel>{t("Priority")}</InputLabel>
// //                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
// //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// //                   </Select>
// //                 </FormControl>
// //               </Grid>

// //               <Grid item xs={12} sm={6}>
// //                 <FormControl fullWidth>
// //                   <InputLabel>{t("Assign To Technician")}</InputLabel>
// //                   <Select
// //                     name="assigned_technician"
// //                     value={formData.assigned_technician}
// //                     label={t("Assign To Technician")}
// //                     onChange={handleChange}
// //                   >
// //                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                       {technicians.map((tech) => (
// //                     <MenuItem key={tech.id} value={tech.id}>
// //                       {/* 🛠️ Logic: If names exist, show "First Last". If not, show "Username" */}
// //                       {(tech.first_name || tech.last_name) 
// //                       ? `${tech.first_name || ''} ${tech.last_name || ''}`.trim() 
// //                       : tech.username || tech.email}
// //                         </MenuItem>
// //                 ))}
                   
                   
// //                                      </Select>
// //                 </FormControl>
// //               </Grid>

// //               <Grid item xs={12}>
// //                 <Box display="flex" gap={2} mt={1}>
// //                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none', px: 4 }}>
// //                     {t("CREATE ISSUE")}
// //                   </Button>
// //                   <Button variant="outlined" color="secondary" size="large" sx={{ textTransform: 'none' }} onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "OPEN", assigned_technician: ""})}>
// //                     {t("ΚΑΘΑΡΙΣΜΟΣ")}
// //                   </Button>
// //                 </Box>
// //               </Grid>
// //             </Grid>
// //           </form>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default CreateIssue;


// // import { useState, useEffect } from "react";
// // import {
// //   Box, Card, CardContent, Typography, TextField, Button,
// //   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// // } from "@mui/material";
// // import axiosClient from "../axiosClient";
// // import { useTranslation } from "react-i18next";


// // const res = await axiosClient.get("auth/users/?user_role=TECHNICIAN");

// // const CreateIssue = () => {
// //   const { t } = useTranslation();
// //   const [technicians, setTechnicians] = useState([]);
// //   const [message, setMessage] = useState(null);
// //   const [error, setError] = useState(null);

// //   const [formData, setFormData] = useState({
// //     title: "",
// //     description: "",
// //     room_number: "",
// //     priority: "MEDIUM",
// //     status: "open", // Matched to your Model's STATUS_CHOICES (lowercase)
// //     assigned_technician: "", 
// //   });

// //   useEffect(() => {
// //     const fetchTechs = async () => {
// //       try {
// //         // 🛠️ CRITICAL FIX: Fetch from users filtered by role
// //         // This ensures row.id is the User ID required by the Issue model
// //         const res = await axiosClient.get("api/users/?user_role=TECHNICIAN");
// //         const techData = Array.isArray(res.data) ? res.data : (res.data.results || []);
// //         setTechnicians(techData);
// //       } catch (err) {
// //         console.error("Could not fetch technicians", err);
// //       }
// //     };
// //     fetchTechs();
// //   }, []);

// //   const handleChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setError(null);
// //     setMessage(null);

// //     try {
// //       const dataToSubmit = {
// //         ...formData,
// //         // Send null if empty string to satisfy Django ForeignKey
// //         assigned_technician: formData.assigned_technician || null
// //       };

// //       await axiosClient.post("api/issues/", dataToSubmit);
// //       setMessage(t("Issue created successfully!"));
// //       setFormData({
// //         title: "", description: "", room_number: "", 
// //         priority: "MEDIUM", status: "open", assigned_technician: "",
// //       });
// //     } catch (err) {
// //       console.error("Submit Error:", err.response?.data);
// //       // Backend usually returns an object of errors {field: ["error message"]}
// //       setError(err.response?.data || t("Error creating issue"));
// //     }
// //   };

// //   return (
// //     <Box display="flex" justifyContent="center" mt={4} mb={4}>
// //       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
// //         <CardContent sx={{ p: 4 }}>
// //           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
// //             {t("Log New Issue / Ticket")}
// //           </Typography>

// //           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
// //           {error && (
// //             <Alert severity="error" sx={{ mb: 2 }}>
// //               {typeof error === 'object' 
// //                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
// //                 : t("Please check the fields and try again.")}
// //             </Alert>
// //           )}

// //           <form onSubmit={handleSubmit}>
// //             <Grid container spacing={3}>
// //               <Grid item xs={12} sm={8}>
// //                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
// //               </Grid>

// //               <Grid item xs={12} sm={4}>
// //                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
// //               </Grid>

// //               <Grid item xs={12}>
// //                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
// //               </Grid>

// //               <Grid item xs={12} sm={6}>
// //                 <FormControl fullWidth>
// //                   <InputLabel>{t("Priority")}</InputLabel>
// //                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
// //                     <MenuItem value="LOW">{t("Low")}</MenuItem>
// //                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
// //                     <MenuItem value="HIGH">{t("High")}</MenuItem>
// //                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
// //                   </Select>
// //                 </FormControl>
// //               </Grid>

// //               <Grid item xs={12} sm={6}>
// //                 <FormControl fullWidth>
// //                   <InputLabel id="tech-label">{t("Assign To Technician")}</InputLabel>
// //                   <Select
// //                     labelId="tech-label"
// //                     name="assigned_technician"
// //                     value={formData.assigned_technician}
// //                     label={t("Assign To Technician")}
// //                     onChange={handleChange}
// //                   >
// //                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
// //                     {technicians.map((tech) => (
// //                       <MenuItem key={tech.id} value={tech.id}>
// //                         {/* 🛠️ Show Full Name if available, otherwise fallback to Username */}
// //                         {tech.first_name || tech.last_name 
// //                           ? `${tech.first_name || ''} ${tech.last_name || ''}`.trim() 
// //                           : tech.username || tech.email}
// //                       </MenuItem>
// //                     ))}
// //                   </Select>
// //                 </FormControl>
// //               </Grid>

// //               <Grid item xs={12}>
// //                 <Box display="flex" gap={2} mt={1}>
// //                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none', px: 4 }}>
// //                     {t("CREATE ISSUE")}
// //                   </Button>
// //                   <Button variant="outlined" color="secondary" size="large" sx={{ textTransform: 'none' }} onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: ""})}>
// //                     {t("ΚΑΘΑΡΙΣΜΟΣ")}
// //                   </Button>
// //                 </Box>
// //               </Grid>
// //             </Grid>
// //           </form>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // };

// // export default CreateIssue;


// ////////////////////////////////////////////////////////

// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const [technicians, setTechnicians] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//   });

//   useEffect(() => {
//     const fetchTechs = async () => {
//       try {
//         // 🛠️ CRITICAL FIX: Updated path from 'api/users/' to 'auth/users/' 
//         // to match your URL configuration and fix the 404 error.
//         const res = await axiosClient.get("auth/users/?user_role=TECHNICIAN");
//         const techData = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         setTechnicians(techData);
//       } catch (err) {
//         console.error("Could not fetch technicians", err);
//       }
//     };
//     fetchTechs();
//   }, []);

//   // useEffect(() => {
//   //   const fetchTechs = async () => {
//   //     try {
//   //       // Change the URL to point to your updated TechnicianListView
//   //       // This view is already coded to include both TECHNICIAN and MAID
//   //       const res = await axiosClient.get("api/technicians/"); 
        
//   //       const techData = Array.isArray(res.data) ? res.data : (res.data.results || []);
//   //       setTechnicians(techData);
//   //     } catch (err) {
//   //       console.error("Could not fetch technicians", err);
//   //     }
//   //   };
//   //   fetchTechs();
//   // }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         assigned_technician: formData.assigned_technician || null
//       };

//       // Ensure this endpoint matches your calendar_project/urls.py
//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//       });
//     } catch (err) {
//       console.error("Submit Error:", err.response?.data);
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="tech-label">{t("Assign To Technician")}</InputLabel>
//                   <Select
//                     labelId="tech-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Technician")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {technicians.map((tech) => (
//                       <MenuItem key={tech.id} value={tech.id}>
//                         {tech.first_name || tech.last_name 
//                           ? `${tech.first_name || ''} ${tech.last_name || ''}`.trim() 
//                           : tech.username || tech.email}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={1}>
//                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none', px: 4 }}>
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button variant="outlined" color="secondary" size="large" sx={{ textTransform: 'none' }} onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: ""})}>
//                     {t("ΚΑΘΑΡΙΣΜΟΣ")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;


// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//   });

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         // Confirmed path from your 404 error screen
//         const res = await axiosClient.get("auth/users/");
        
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
        
//         // Filter to only include Technician and Maid roles
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
        
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         assigned_technician: formData.assigned_technician || null
//       };

//       // Pattern #4 in your URLConf
//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//       });
//     } catch (err) {
//       console.error("Submit Error:", err.response?.data);
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         {/* Using standard fields from UserSerializer */}
//                         {user.first_name || user.last_name 
//                           ? `${user.first_name || ''} ${user.last_name || ''}`.trim() 
//                           : user.email}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={1}>
//                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none', px: 4 }}>
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button 
//                     variant="outlined" 
//                     color="secondary" 
//                     size="large" 
//                     sx={{ textTransform: 'none' }} 
//                     onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: ""})}
//                   >
//                     {t("RESET")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;

/////////////////////////

// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//   });

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
        
//         // Filter for both roles
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
        
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         assigned_technician: formData.assigned_technician || null
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//       });
//     } catch (err) {
//       console.error("Submit Error:", err.response?.data);
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>
//                             {user.first_name || user.last_name 
//                               ? `${user.first_name || ''} ${user.last_name || ''}`.trim() 
//                               : user.email}
//                           </Typography>
//                           <Typography 
//                             variant="caption" 
//                             sx={{ 
//                               ml: 2, 
//                               fontWeight: 'bold',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               border: `1px solid ${user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"}`,
//                               borderRadius: '4px',
//                               px: 0.5
//                             }}
//                           >
//                             {user.user_role}
//                           </Typography>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* ACTION BUTTONS SECTION */}
//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={2} justifyContent="flex-start">
//                   <Button 
//                     type="submit" 
//                     variant="contained" 
//                     color="primary" 
//                     size="large" 
//                     sx={{ textTransform: 'none', minWidth: '180px' }}
//                   >
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button 
//                     variant="outlined" 
//                     color="secondary" 
//                     size="large" 
//                     sx={{ textTransform: 'none' }} 
//                     onClick={() => setFormData({
//                       title: "", description: "", room_number: "", 
//                       priority: "MEDIUM", status: "open", assigned_technician: ""
//                     })}
//                   >
//                     {t("RESET")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;


///////////////////////////////

// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//     closed_at: "", // New field for manual End Date/Time
//   });

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
        
//         // Filter for both roles
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
        
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         assigned_technician: formData.assigned_technician || null,
//         // Send null if closed_at is empty
//         closed_at: formData.closed_at || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
      
//       // Reset Form
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//         closed_at: "",
//       });
//     } catch (err) {
//       console.error("Submit Error:", err.response?.data);
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>
//                             {user.first_name || user.last_name 
//                               ? `${user.first_name || ''} ${user.last_name || ''}`.trim() 
//                               : user.email}
//                           </Typography>
//                           <Typography 
//                             variant="caption" 
//                             sx={{ 
//                               ml: 2, 
//                               fontWeight: 'bold',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               border: `1px solid ${user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"}`,
//                               borderRadius: '4px',
//                               px: 0.5
//                             }}
//                           >
//                             {user.user_role}
//                           </Typography>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} label={t("Status")} onChange={handleChange}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="closed_at"
//                   label={t("Manual End Date/Time")}
//                   type="datetime-local"
//                   value={formData.closed_at}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={2} justifyContent="flex-start">
//                   <Button 
//                     type="submit" 
//                     variant="contained" 
//                     color="primary" 
//                     size="large" 
//                     sx={{ textTransform: 'none', minWidth: '180px' }}
//                   >
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button 
//                     variant="outlined" 
//                     color="secondary" 
//                     size="large" 
//                     sx={{ textTransform: 'none' }} 
//                     onClick={() => setFormData({
//                       title: "", description: "", room_number: "", 
//                       priority: "MEDIUM", status: "open", assigned_technician: "",
//                       closed_at: "",
//                     })}
//                   >
//                     {t("RESET")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;


////////////////////

// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//     closed_at: "", 
//   });

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         assigned_technician: formData.assigned_technician || null,
//         closed_at: formData.closed_at || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
      
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//         closed_at: "",
//       });
//     } catch (err) {
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>
//                             {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email}
//                           </Typography>
//                           <Typography 
//                             variant="caption" 
//                             sx={{ 
//                               ml: 2, 
//                               fontWeight: 'bold',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               border: `1px solid ${user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"}`,
//                               borderRadius: '4px',
//                               px: 0.5
//                             }}
//                           >
//                             {user.user_role}
//                           </Typography>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} label={t("Status")} onChange={handleChange}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="closed_at"
//                   label={t("Manual End Date/Time")}
//                   type="datetime-local"
//                   value={formData.closed_at}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={2} justifyContent="flex-start">
//                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none', minWidth: '180px' }}>
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button variant="outlined" color="secondary" size="large" sx={{ textTransform: 'none' }} 
//                     onClick={() => setFormData({
//                       title: "", description: "", room_number: "", 
//                       priority: "MEDIUM", status: "open", assigned_technician: "",
//                       closed_at: "",
//                     })}
//                   >
//                     {t("RESET")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;

// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//     // 🛠️ ADDED: start_date for Calendar synchronization
//     start_date: "", 
//     closed_at: "", 
//   });

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         assigned_technician: formData.assigned_technician || null,
//         // 🛠️ Logic: Map start_date to created_at so it shows on the calendar
//         created_at: formData.start_date || null,
//         closed_at: formData.closed_at || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created and added to calendar successfully!"));
      
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//         start_date: "",
//         closed_at: "",
//       });
//     } catch (err) {
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               {/* 🛠️ ADDED: STARTING DATE/TIME PICKER */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="start_date"
//                   label={t("Starting Date/Time (Calendar Start) *")}
//                   type="datetime-local"
//                   value={formData.start_date}
//                   onChange={handleChange}
//                   required
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="closed_at"
//                   label={t("Manual End Date/Time")}
//                   type="datetime-local"
//                   value={formData.closed_at}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>
//                             {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email}
//                           </Typography>
//                           <Typography 
//                             variant="caption" 
//                             sx={{ 
//                               ml: 2, 
//                               fontWeight: 'bold',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               border: `1px solid ${user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"}`,
//                               borderRadius: '4px',
//                               px: 0.5
//                             }}
//                           >
//                             {user.user_role}
//                           </Typography>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} label={t("Status")} onChange={handleChange}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={2} justifyContent="flex-start">
//                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none', minWidth: '180px' }}>
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button variant="outlined" color="secondary" size="large" sx={{ textTransform: 'none' }} 
//                     onClick={() => setFormData({
//                       title: "", description: "", room_number: "", 
//                       priority: "MEDIUM", status: "open", assigned_technician: "",
//                       start_date: "",
//                       closed_at: "",
//                     })}
//                   >
//                     {t("RESET")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;


///////////////////////////////////////////////////////////////////////// 


// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid,
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider"; // 🛠️ Import context

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const { date } = useStateContext(); // 🛠️ Get the date from calendar click
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//     start_date: "", 
//     closed_at: "", 
//   });

//   // 🛠️ Auto-fill date if it comes from the calendar
//   useEffect(() => {
//     if (date) {
//       setFormData(prev => ({
//         ...prev,
//         start_date: `${date}T09:00` // Default to 9:00 AM on the selected day
//       }));
//     }
//   }, [date]);

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         ...formData,
//         // 🛠️ Ensure this is a number to trigger backend SMS signals
//         assigned_technician: formData.assigned_technician ? Number(formData.assigned_technician) : null,
//         created_at: formData.start_date || null,
//         closed_at: formData.closed_at || null,
//         // 🛠️ Hint to backend to trigger the notification service
//         send_sms_notification: true 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created and SMS notification sent successfully!"));
      
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//         start_date: "",
//         closed_at: "",
//       });
//     } catch (err) {
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {typeof error === 'object' 
//                 ? Object.entries(error).map(([k, v]) => `${k}: ${v}`).join(", ") 
//                 : t("Please check the fields and try again.")}
//             </Alert>
//           )}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="start_date"
//                   label={t("Starting Date/Time (Calendar Start) *")}
//                   type="datetime-local"
//                   value={formData.start_date}
//                   onChange={handleChange}
//                   required
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="closed_at"
//                   label={t("Manual End Date/Time")}
//                   type="datetime-local"
//                   value={formData.closed_at}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>
//                             {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email}
//                           </Typography>
//                           <Typography 
//                             variant="caption" 
//                             sx={{ 
//                               ml: 2, 
//                               fontWeight: 'bold',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               border: `1px solid ${user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"}`,
//                               borderRadius: '4px',
//                               px: 0.5
//                             }}
//                           >
//                             {user.user_role}
//                           </Typography>
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} label={t("Status")} onChange={handleChange}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={2} justifyContent="flex-start">
//                   <Button type="submit" variant="contained" color="primary" size="large" sx={{ textTransform: 'none', minWidth: '180px' }}>
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button variant="outlined" color="secondary" size="large" sx={{ textTransform: 'none' }} 
//                     onClick={() => setFormData({
//                       title: "", description: "", room_number: "", 
//                       priority: "MEDIUM", status: "open", assigned_technician: "",
//                       start_date: "",
//                       closed_at: "",
//                     })}
//                   >
//                     {t("RESET")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;


////////////////////////////////////////////////////////////////////////


// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid, Chip
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const { date, setDate } = useStateContext(); 
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//     start_date: "", 
//     closed_at: "", 
//   });

//   useEffect(() => {
//     if (date) {
//       setFormData(prev => ({
//         ...prev,
//         start_date: `${date}T09:00` 
//       }));
//     }
//   }, [date]);

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         title: formData.title,
//         description: formData.description,
//         room_number: formData.room_number,
//         priority: formData.priority,
//         status: formData.status,
//         assigned_technician: formData.assigned_technician || null,
//         // 🛠️ Mapping to the new non-readonly backend field
//         scheduled_start: formData.start_date || null,
//         closed_at: formData.closed_at || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created and added to calendar successfully!"));
      
//       // Reset global date and local form
//       setDate("");
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//         start_date: "",
//         closed_at: "",
//       });
//     } catch (err) {
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && <Alert severity="error" sx={{ mb: 2 }}>{t("Check fields and try again")}</Alert>}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField fullWidth name="start_date" label={t("Starting Date/Time *")} type="datetime-local" value={formData.start_date} onChange={handleChange} required InputLabelProps={{ shrink: true }} />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField fullWidth name="closed_at" label={t("Manual End Date/Time")} type="datetime-local" value={formData.closed_at} onChange={handleChange} InputLabelProps={{ shrink: true }} />
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Priority")}</InputLabel>
//                   <Select name="priority" value={formData.priority} label={t("Priority")} onChange={handleChange}>
//                     <MenuItem value="LOW">{t("Low")}</MenuItem>
//                     <MenuItem value="MEDIUM">{t("Medium")}</MenuItem>
//                     <MenuItem value="HIGH">{t("High")}</MenuItem>
//                     <MenuItem value="URGENT">{t("Urgent")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* 🛠️ RESTORED SELECTION STYLE WITH COLORED LABELS */}
//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>
//                             {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email}
//                           </Typography>
//                           {/* 🎨 Chip labels matching your image */}
//                           <Chip 
//                             label={user.user_role} 
//                             size="small" 
//                             variant="outlined" 
//                             sx={{ 
//                               ml: 1,
//                               fontSize: '10px',
//                               height: '20px',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               borderColor: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                             }} 
//                           />
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={4}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} label={t("Status")} onChange={handleChange}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={2}>
//                   <Button type="submit" variant="contained" color="primary" fullWidth size="large">{t("CREATE ISSUE")}</Button>
//                   <Button variant="outlined" color="secondary" fullWidth size="large" onClick={() => setFormData({ title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: "", start_date: "", closed_at: "" })}>{t("RESET")}</Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;





///////////////////////////////////////////////////////////////

// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid, Chip
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const { date, setDate } = useStateContext(); 
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "", description: "", room_number: "",
//     priority: "MEDIUM", status: "open", assigned_technician: "",
//     start_date: "", closed_at: "",
//   });

//   useEffect(() => {
//     if (date) {
//       setFormData(prev => ({ ...prev, start_date: `${date}T09:00` }));
//     }
//   }, [date]);

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
//       } catch (err) { console.error("Staff fetch error", err); }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         title: formData.title,
//         description: formData.description,
//         room_number: formData.room_number,
//         priority: formData.priority,
//         status: formData.status,
//         assigned_technician: formData.assigned_technician ? Number(formData.assigned_technician) : null,
//         // 🛠️ USE THE NEW FIELD NAME HERE
//         scheduled_start: formData.start_date || null,
//         closed_at: formData.closed_at || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created and added to calendar!"));
//       setDate(""); // Reset context date
//       setFormData({ title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: "", start_date: "", closed_at: "" });
//     } catch (err) {
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">{t("Log New Issue / Ticket")}</Typography>
//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
          
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}><TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required /></Grid>
//               <Grid item xs={12} sm={4}><TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required /></Grid>
//               <Grid item xs={12}><TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required /></Grid>
              
//               <Grid item xs={12} sm={6}>
//                 <TextField fullWidth name="start_date" label={t("Starting Date/Time *")} type="datetime-local" value={formData.start_date} onChange={handleChange} required InputLabelProps={{ shrink: true }} />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select labelId="staff-label" name="assigned_technician" value={formData.assigned_technician} label={t("Assign To Staff")} onChange={handleChange}>
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>{`${user.first_name} ${user.last_name}`}</Typography>
//                           <Chip 
//                             label={user.user_role} 
//                             size="small" 
//                             variant="outlined" 
//                             sx={{ color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63", borderColor: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63" }} 
//                           />
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}><Button type="submit" variant="contained" fullWidth size="large">{t("CREATE ISSUE")}</Button></Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };
// export default CreateIssue;


////////////////////////

// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid, Chip
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const { date, setDate } = useStateContext(); 
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     room_number: "",
//     priority: "MEDIUM",
//     status: "open", 
//     assigned_technician: "", 
//     start_date: "", 
//     closed_at: "", 
//   });

//   // Auto-fill date if it comes from the calendar
//   useEffect(() => {
//     if (date) {
//       setFormData(prev => ({
//         ...prev,
//         start_date: `${date}T09:00` 
//       }));
//     }
//   }, [date]);

//   // Fetch only Technicians and Maids
//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         const assignable = allUsers.filter(u => 
//           u.user_role === "TECHNICIAN" || u.user_role === "MAID"
//         );
//         setStaffList(assignable);
//       } catch (err) {
//         console.error("Could not fetch staff", err);
//       }
//     };
//     fetchStaff();
//   }, []);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setMessage(null);

//     try {
//       const dataToSubmit = {
//         title: formData.title,
//         description: formData.description,
//         room_number: formData.room_number,
//         priority: formData.priority,
//         status: formData.status,
//         assigned_technician: formData.assigned_technician || null,
//         // 🛠️ Mapping start_date to the NEW backend field 'scheduled_start'
//         scheduled_start: formData.start_date || null,
//         closed_at: formData.closed_at || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created and added to calendar successfully!"));
      
//       // Reset global date and form
//       if (setDate) setDate(""); 
//       setFormData({
//         title: "", description: "", room_number: "", 
//         priority: "MEDIUM", status: "open", assigned_technician: "",
//         start_date: "",
//         closed_at: "",
//       });
//     } catch (err) {
//       setError(err.response?.data || t("Error creating issue"));
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>

//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           {error && <Alert severity="error" sx={{ mb: 2 }}>{t("Please check the fields and try again.")}</Alert>}

//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={handleChange} required />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={handleChange} required />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={handleChange} required />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="start_date"
//                   label={t("Starting Date/Time *")}
//                   type="datetime-local"
//                   value={formData.start_date}
//                   onChange={handleChange}
//                   required
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   name="closed_at"
//                   label={t("Manual End Date/Time")}
//                   type="datetime-local"
//                   value={formData.closed_at}
//                   onChange={handleChange}
//                   InputLabelProps={{ shrink: true }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel id="staff-label">{t("Assign To Staff")}</InputLabel>
//                   <Select
//                     labelId="staff-label"
//                     name="assigned_technician"
//                     value={formData.assigned_technician}
//                     label={t("Assign To Staff")}
//                     onChange={handleChange}
//                   >
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((user) => (
//                       <MenuItem key={user.id} value={user.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>
//                             {`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email}
//                           </Typography>
//                           <Chip 
//                             label={user.user_role} 
//                             size="small" 
//                             variant="outlined" 
//                             sx={{ 
//                               ml: 1,
//                               fontSize: '10px',
//                               height: '20px',
//                               color: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63",
//                               borderColor: user.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63"
//                             }} 
//                           />
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} label={t("Status")} onChange={handleChange}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Box display="flex" gap={2} mt={2}>
//                   <Button type="submit" variant="contained" color="primary" fullWidth size="large">
//                     {t("CREATE ISSUE")}
//                   </Button>
//                   <Button variant="outlined" color="secondary" fullWidth size="large" onClick={() => setFormData({title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: "", start_date: "", closed_at: ""})}>
//                     {t("RESET")}
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default CreateIssue;



///////////////////////



// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid, Chip
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const { date, setDate } = useStateContext(); 
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "", description: "", room_number: "",
//     priority: "MEDIUM", status: "open", assigned_technician: "", 
//     start_date: "", closed_at: "", 
//   });

//   useEffect(() => {
//     if (date) setFormData(prev => ({ ...prev, start_date: `${date}T09:00` }));
//   }, [date]);

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
//       } catch (err) { console.error("Staff fetch error", err); }
//     };
//     fetchStaff();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const dataToSubmit = {
//         title: formData.title,
//         description: formData.description,
//         room_number: formData.room_number,
//         priority: formData.priority,
//         status: formData.status,
//         assigned_technician: formData.assigned_technician || null,
//         // 🛠️ THIS MAPS TO THE BACKEND FIELD YOU JUST CREATED
//         scheduled_start: formData.start_date || null,
//         closed_at: formData.closed_at || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
//       setDate(""); 
//       setFormData({ title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: "", start_date: "", closed_at: "" });
//     } catch (err) { setError(t("Error creating issue")); }
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, boxShadow: 6, borderRadius: 2 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="primary">
//             {t("Log New Issue / Ticket")}
//           </Typography>
//           {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}><TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} onChange={(e) => setFormData({...formData, title: e.target.value})} required /></Grid>
//               <Grid item xs={12} sm={4}><TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} onChange={(e) => setFormData({...formData, room_number: e.target.value})} required /></Grid>
//               <Grid item xs={12}><TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})} required /></Grid>
//               <Grid item xs={12} sm={6}><TextField fullWidth label={t("Starting Date/Time *")} type="datetime-local" value={formData.start_date} onChange={(e) => setFormData({...formData, start_date: e.target.value})} InputLabelProps={{ shrink: true }} required /></Grid>
//               <Grid item xs={12} sm={6}><TextField fullWidth label={t("Manual End Date/Time")} type="datetime-local" value={formData.closed_at} onChange={(e) => setFormData({...formData, closed_at: e.target.value})} InputLabelProps={{ shrink: true }} /></Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Assign To Staff")}</InputLabel>
//                   <Select name="assigned_technician" value={formData.assigned_technician} label={t("Assign To Staff")} onChange={(e) => setFormData({...formData, assigned_technician: e.target.value})}>
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((u) => (
//                       <MenuItem key={u.id} value={u.id}>
//                         <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
//                           <Typography>{`${u.first_name} ${u.last_name}`}</Typography>
//                           <Chip label={u.user_role} size="small" variant="outlined" sx={{ ml: 1, fontSize: '10px', color: u.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63", borderColor: u.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63" }} />
//                         </Box>
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} label={t("Status")} onChange={(e) => setFormData({...formData, status: e.target.value})}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}><Button type="submit" variant="contained" fullWidth size="large">{t("CREATE ISSUE")}</Button></Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };
// export default CreateIssue;


/////////////////////////////////////////////////////////////////////////////////



// import { useState, useEffect } from "react";
// import {
//   Box, Card, CardContent, Typography, TextField, Button,
//   MenuItem, Select, FormControl, InputLabel, Alert, Grid, Chip
// } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider";

// const CreateIssue = () => {
//   const { t } = useTranslation();
//   const { date, setDate } = useStateContext(); 
//   const [staffList, setStaffList] = useState([]);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: "", description: "", room_number: "",
//     priority: "MEDIUM", status: "open", assigned_technician: "", 
//     start_date: "", end_date: "", 
//   });

//   useEffect(() => {
//     if (date) setFormData(prev => ({ ...prev, start_date: `${date}T09:00` }));
//   }, [date]);

//   useEffect(() => {
//     const fetchStaff = async () => {
//       try {
//         const res = await axiosClient.get("auth/users/");
//         const allUsers = Array.isArray(res.data) ? res.data : (res.data.results || []);
//         setStaffList(allUsers.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
//       } catch (err) { console.error("Staff fetch error", err); }
//     };
//     fetchStaff();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const dataToSubmit = {
//         title: formData.title,
//         description: formData.description,
//         room_number: formData.room_number,
//         priority: formData.priority,
//         status: formData.status,
//         assigned_technician: formData.assigned_technician || null,
//         scheduled_start: formData.start_date || null,
//         scheduled_end: formData.end_date || null 
//       };

//       await axiosClient.post("api/issues/", dataToSubmit);
//       setMessage(t("Issue created successfully!"));
//       setDate(""); 
//       setFormData({ title: "", description: "", room_number: "", priority: "MEDIUM", status: "open", assigned_technician: "", start_date: "", end_date: "" });
//     } catch (err) { setError(t("Error creating issue")); }
//   };

//   // 🛠️ CUSTOM DARK STYLES TO MATCH YOUR SCREENSHOT
//   const textFieldStyle = {
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": { borderColor: "#444" },
//       "&:hover fieldset": { borderColor: "#666" },
//     },
//     "& .MuiInputLabel-root": { color: "#aaa" },
//     "& .MuiInputBase-input": { color: "#fff" },
//     bgcolor: "#2c2c2c"
//   };

//   return (
//     <Box display="flex" justifyContent="center" mt={4} mb={4}>
//       <Card sx={{ width: "100%", maxWidth: 900, bgcolor: "#1e1e1e", color: "#fff", boxShadow: 10 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" mb={3} fontWeight="bold" align="center" color="#90caf9">
//             {t("Log New Issue / Ticket")}
//           </Typography>
          
//           {message && <Alert severity="success" sx={{ mb: 2, bgcolor: "#1b5e20", color: "#fff" }}>{message}</Alert>}
          
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={8}>
//                 <TextField fullWidth label={t("Issue Title *")} name="title" value={formData.title} 
//                   onChange={(e) => setFormData({...formData, title: e.target.value})} required sx={textFieldStyle} />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <TextField fullWidth label={t("Room Number *")} name="room_number" value={formData.room_number} 
//                   onChange={(e) => setFormData({...formData, room_number: e.target.value})} required sx={textFieldStyle} />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField fullWidth label={t("Description *")} name="description" multiline rows={4} value={formData.description} 
//                   onChange={(e) => setFormData({...formData, description: e.target.value})} required sx={textFieldStyle} />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField fullWidth label={t("Starting Date/Time *")} type="datetime-local" value={formData.start_date} 
//                   onChange={(e) => setFormData({...formData, start_date: e.target.value})} InputLabelProps={{ shrink: true }} required sx={textFieldStyle} />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField fullWidth label={t("Manual End Date/Time")} type="datetime-local" value={formData.end_date} 
//                   onChange={(e) => setFormData({...formData, end_date: e.target.value})} InputLabelProps={{ shrink: true }} sx={textFieldStyle} />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth sx={textFieldStyle}>
//                   <InputLabel sx={{ color: "#aaa" }}>{t("Assign To Staff")}</InputLabel>
//                   <Select name="assigned_technician" value={formData.assigned_technician} 
//                     onChange={(e) => setFormData({...formData, assigned_technician: e.target.value})}
//                     sx={{ color: "#fff", ".MuiOutlinedInput-notchedOutline": { borderColor: "#444" } }}>
//                     <MenuItem value=""><em>{t("None")}</em></MenuItem>
//                     {staffList.map((u) => (
//                       <MenuItem key={u.id} value={u.id} sx={{ justifyContent: "space-between" }}>
//                         <Typography variant="body2">{`${u.first_name} ${u.last_name}`}</Typography>
//                         <Chip label={u.user_role} size="small" variant="outlined" 
//                           sx={{ ml: 1, fontSize: '10px', color: u.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63", borderColor: u.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63" }} />
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth sx={textFieldStyle}>
//                   <InputLabel sx={{ color: "#aaa" }}>{t("Status")}</InputLabel>
//                   <Select name="status" value={formData.status} onChange={(e) => setFormData({...formData, status: e.target.value})}
//                     sx={{ color: "#fff", ".MuiOutlinedInput-notchedOutline": { borderColor: "#444" } }}>
//                     <MenuItem value="open">{t("Open")}</MenuItem>
//                     <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
//                     <MenuItem value="resolved">{t("Resolved")}</MenuItem>
//                     <MenuItem value="closed">{t("Closed")}</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12}>
//                 <Button type="submit" variant="contained" fullWidth size="large" sx={{ bgcolor: "#90caf9", color: "#000", "&:hover": { bgcolor: "#64b5f6" } }}>
//                   {t("CREATE ISSUE")}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };
// export default CreateIssue;

//////////////////////////////////////////////////////////////////////////////////////////////

// import { useState, useEffect } from "react";
// import { Box, Card, CardContent, Typography, TextField, Button, MenuItem, Select, FormControl, InputLabel, Grid, Chip } from "@mui/material";
// import axiosClient from "../axiosClient";
// import { useStateContext } from "../context/ContextProvider";

// const CreateIssue = () => {
//   const { date, setDate, setView } = useStateContext();
//   const [staffList, setStaffList] = useState([]);
//   const [formData, setFormData] = useState({ title: "", room_number: "", description: "", start_date: "", end_date: "", assigned_technician: "" });

//   useEffect(() => {
//     if (date) setFormData(prev => ({ ...prev, start_date: `${date}T09:00` }));
//     axiosClient.get("auth/users/").then(res => {
//       const users = Array.isArray(res.data) ? res.data : (res.data.results || []);
//       setStaffList(users.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
//     });
//   }, [date]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await axiosClient.post("api/issues/", {
//         ...formData,
//         scheduled_start: formData.start_date,
//         scheduled_end: formData.end_date || null,
//       });
//       setDate(""); setView("calendar");
//     } catch (err) { alert("Error saving issue."); }
//   };

//   const fieldStyle = { bgcolor: "#2c2c2c", input: { color: "white" }, label: { color: "#bbb" }, "& .MuiOutlinedInput-notchedOutline": { borderColor: "#444" } };

//   return (
//     <Box sx={{ p: 4, display: "flex", justifyContent: "center", bgcolor: "#121212", minHeight: "100vh" }}>
//       <Card sx={{ maxWidth: 900, width: "100%", bgcolor: "#1e1e1e", color: "white", boxShadow: 8 }}>
//         <CardContent sx={{ p: 4 }}>
//           <Typography variant="h5" align="center" sx={{ mb: 4, color: "#90caf9", fontWeight: "bold" }}>Log New Issue / Ticket</Typography>
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={8}><TextField fullWidth label="Issue Title *" sx={fieldStyle} value={formData.title} onChange={e => setFormData({ ...formData, title: e.target.value })} required /></Grid>
//               <Grid item xs={12} sm={4}><TextField fullWidth label="Room Number *" sx={fieldStyle} value={formData.room_number} onChange={e => setFormData({ ...formData, room_number: e.target.value })} required /></Grid>
//               <Grid item xs={12} sm={6}><TextField fullWidth type="datetime-local" label="Starting Date/Time *" InputLabelProps={{ shrink: true }} sx={fieldStyle} value={formData.start_date} onChange={e => setFormData({ ...formData, start_date: e.target.value })} required /></Grid>
//               <Grid item xs={12} sm={6}><TextField fullWidth type="datetime-local" label="Manual End Date/Time" InputLabelProps={{ shrink: true }} sx={fieldStyle} value={formData.end_date} onChange={e => setFormData({ ...formData, end_date: e.target.value })} /></Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth sx={fieldStyle}>
//                   <InputLabel sx={{ color: "#bbb" }}>Assign To Staff</InputLabel>
//                   <Select value={formData.assigned_technician} onChange={e => setFormData({ ...formData, assigned_technician: e.target.value })} sx={{ color: "white" }}>
//                     {staffList.map(u => (
//                       <MenuItem key={u.id} value={u.id} sx={{ justifyContent: "space-between" }}>
//                         {u.first_name} {u.last_name} <Chip label={u.user_role} size="small" variant="outlined" sx={{ ml: 1, fontSize: '10px', color: u.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63" }} />
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}><TextField fullWidth label="Description" multiline rows={4} sx={fieldStyle} value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} /></Grid>
//               <Grid item xs={12}><Button type="submit" variant="contained" fullWidth sx={{ py: 1.5, bgcolor: "#90caf9", color: "black", fontWeight: "bold" }}>CREATE ISSUE</Button></Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };
// export default CreateIssue;


///////////////////////////////////////////////////////////////

import { useState, useEffect } from "react";
import {
  Box, Card, CardContent, Typography, TextField, Button,
  MenuItem, Select, FormControl, InputLabel, Alert, Grid, Chip
} from "@mui/material";
import axiosClient from "../axiosClient";
import { useTranslation } from "react-i18next";
import { useStateContext } from "../context/ContextProvider";

const CreateIssue = () => {
  const { t } = useTranslation();
  const { date, setDate, setView } = useStateContext(); 
  const [staffList, setStaffList] = useState([]);
  const [message, setMessage] = useState(null);

  const [formData, setFormData] = useState({
    title: "", description: "", room_number: "",
    priority: "MEDIUM", status: "open", assigned_technician: "", 
    start_date: "", end_date: "", 
  });

  useEffect(() => {
    if (date) setFormData(prev => ({ ...prev, start_date: `${date}T09:00` }));
  }, [date]);

  // 🛠️ FETCH STAFF LOGIC (Crucial for the dropdown to work)
  useEffect(() => {
    axiosClient.get("auth/users/").then(res => {
      const users = Array.isArray(res.data) ? res.data : (res.data.results || []);
      // Filter for Technicians and Maids only
      setStaffList(users.filter(u => u.user_role === "TECHNICIAN" || u.user_role === "MAID"));
    }).catch(err => console.error("Staff fetch error", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await axiosClient.post("api/issues/", {
      await axiosClient.post("issues/", {
        ...formData,
        scheduled_start: formData.start_date,
        scheduled_end: formData.end_date || null 
      });
      setMessage(t("Issue created successfully!"));
      setDate(""); 
      setView("appointments"); // Go back to calendar
    } catch (err) { console.error(err); }
  };

  const textFieldStyle = {
    "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "#444" } },
    "& .MuiInputLabel-root": { color: "#aaa" },
    "& .MuiInputBase-input": { color: "#fff" },
    bgcolor: "#2c2c2c"
  };

  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <Card sx={{ width: "100%", maxWidth: 900, bgcolor: "#1e1e1e", color: "#fff" }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" mb={3} align="center" color="#90caf9">{t("Log New Issue / Ticket")}</Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={8}><TextField fullWidth label="Title *" sx={textFieldStyle} value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} required /></Grid>
              <Grid item xs={12} sm={4}><TextField fullWidth label="Room *" sx={textFieldStyle} value={formData.room_number} onChange={e => setFormData({...formData, room_number: e.target.value})} required /></Grid>
              
              <Grid item xs={12}><TextField fullWidth label="Description *" multiline rows={4} sx={textFieldStyle} value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} required /></Grid>

              <Grid item xs={12} sm={6}><TextField fullWidth type="datetime-local" label="Start Date *" InputLabelProps={{ shrink: true }} sx={textFieldStyle} value={formData.start_date} onChange={e => setFormData({...formData, start_date: e.target.value})} required /></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth type="datetime-local" label="End Date" InputLabelProps={{ shrink: true }} sx={textFieldStyle} value={formData.end_date} onChange={e => setFormData({...formData, end_date: e.target.value})} /></Grid>

              {/* 🛠️ RESTORED STAFF DROPDOWN */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={textFieldStyle}>
                  <InputLabel sx={{ color: "#aaa" }}>{t("Assign To Staff")}</InputLabel>
                  <Select 
                    value={formData.assigned_technician} 
                    label={t("Assign To Staff")}
                    onChange={e => setFormData({...formData, assigned_technician: e.target.value})}
                    sx={{ color: "white" }}
                  >
                    <MenuItem value=""><em>{t("None")}</em></MenuItem>
                    {staffList.map((u) => (
                      <MenuItem key={u.id} value={u.id} sx={{ justifyContent: "space-between" }}>
                        <Typography variant="body2">{`${u.first_name} ${u.last_name}`}</Typography>
                        <Chip 
                          label={u.user_role} 
                          size="small" 
                          variant="outlined" 
                          sx={{ ml: 1, fontSize: '10px', color: u.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63", borderColor: u.user_role === "TECHNICIAN" ? "#2196f3" : "#e91e63" }} 
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={textFieldStyle}>
                  <InputLabel sx={{ color: "#aaa" }}>{t("Status")}</InputLabel>
                  <Select value={formData.status} onChange={e => setFormData({...formData, status: e.target.value})} sx={{ color: "white" }}>
                    <MenuItem value="open">{t("Open")}</MenuItem>
                    <MenuItem value="in_progress">{t("In Progress")}</MenuItem>
                    <MenuItem value="resolved">{t("Resolved")}</MenuItem>
                    <MenuItem value="closed">{t("Closed")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}><Button type="submit" variant="contained" fullWidth sx={{ bgcolor: "#90caf9", color: "#000", fontWeight: "bold" }}>{t("CREATE ISSUE")}</Button></Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};
export default CreateIssue;